<template>
  <div class="wapper">
    <div class="images-wapper">
      <span class="title">方案内容</span>
      <div class="plan-table-title-one">折算业绩与提成方案表</div>
      <div class="new-table-wapper">
        <!-- 提成方案 start -->
        <div class="table-one" v-if="info.planSales && info.planSales.length > 0">
          <div class="plan-table-wapper">
            <table class="plan-table-title">
              <tr style="text-align:left;font-weight: normal;">
                <td style="width: 65px;">类型</td>
                <td style="width: 150px;">实际售价</td>
                <td style="width: 65px;">销售提成</td>
                <td style="width: 65px;">经理提成</td>
                <td style="width: 65px;">总监提成</td>
                <td style="width: 100px;">售价折算业绩系数</td>
              </tr>
            </table>
            <table v-for="(plan, planIndex) in info.planSales" :key="planIndex">
              <tr>
                <td colspan="6">
                  销售总金额大于 {{ plan.salesAmount | thousandBitSeparator }} 元
                </td>
              </tr>
              <tr v-for="(item, index) in plan.list" :key="index">
                <td style="width: 65px;">{{ item.isSection == 1 ? "区间售价" : "标准售价" }}</td>
                <!-- 标准售价 -->
                <td v-if="item.isSection == 2" style="width: 150px;">
                  {{ item.lowestPrice.toFixed(2) }}元
                </td>
                <!-- 区间售价 -->
                <td style="width: 150px;" v-else>
                  {{ item.lowestPrice.toFixed(2) }}元(含) ~ {{ item.maximumPrice.toFixed(2) }}元(不含)
                </td>
                <td style="width: 65px;" class="saleRoyalty-color" >
                  {{ item.saleRoyalty }}%
                </td>
                <td style="width: 65px;">
                  {{ item.managerRoyalty }}%
                </td>
                <td style="width: 65px;" >
                  {{ item.directorRoyalty }}%
                </td>
                <td style="width: 100px;color: #F59A23;" class="saleConversionFactor-color" >
                  {{ formatPercent(item.saleConversionFactor) }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- end -->
        <!-- 销售提成系数 -->
        <div v-if="info.flagPackage==1 && info.packageList && info.packageList.length > 0" class="sale-conversion-factor-wapper">
          <div class="sale-new-table-title">
              <p class="sale-new-table-title-text">销售提成系数（由运营在创建模版时选择）</p>
              <div class="package-list-wapper">
                <!-- 新增tooltip提示   -->
                 <div class="package-list-item" v-for="item in info.packageList" :key="item.id">
                   <el-tooltip :content="item.fieldName" placement="top">
                    <span >{{ item.fieldName }}</span>
                   </el-tooltip>
                 </div>
              </div>
          </div>
          <div class="package-table-wapper">
            <el-table v-for="item in info.packageList " :data="item.planPckageList" size="mini" :border="true">
              <el-table-column label="选项" prop="fieldName" show-overflow-tooltip></el-table-column>
              <el-table-column label="销售提成系数" prop="fieldConfig" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="pack-color" >{{ scope.row.fieldConfig }}%</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 有效期折算业绩系数 start -->
        <div class="table-two" v-if="info.conversionValidityList && info.conversionValidityList.length > 0">
          <div class="new-table-title">有效期折算业绩系数</div>
          <el-table :data="info.conversionValidityList" size="mini" empty-text :border="true">
            <el-table-column label="有效期区间" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.minMonth }}个月(含)</span> ~
                <span>{{ scope.row.maxMonth }}个月(不含)</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期折算业绩系数" width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="coefficient-color" >{{ scope.row.coefficient }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- end -->
        <!-- 适用应用规则 start -->
        <div class="table-thr" v-if="info.flagPaltform==1">
          <div class="new-table-title">适用应用规则折算业绩系数</div>
          <div class="performanceRule-table" v-if="info.flagPaltform == 1">
            <p class="cell">{{ info.platformMatchType == 1 ? '如果满足以下任意条件之一' : '如果同时满足以下所有条件' }}</p>
            <p class="condition" v-for="item in info.performanceRuleList" :key="item.id">条件：应用规则{{ item.relationType == '1' ? '包含' : '不包含' }} {{ item.platformName }}-{{ item.appRuleName }}</p>
            <p class="cell">那么适用应用规则折算业绩系数=</p>
            <p class="performanceRuleFactor">{{ info.performanceRuleFactor }}%</p>
          </div>
        </div>
        <div class="table-five" v-if="info.budgetConversionFactor != null">
          <div class="new-table-title">预算范围折算业绩系数</div>
          <div class="budgetConversionFactor color-blue">{{ info.budgetConversionFactor }}%</div>
        </div>
        <!-- VIP劵包 start -->
        <div class="table-four" v-if="info.vipCouponList && info.vipCouponList.length > 0">
          <div class="new-table-title">VIP劵包折算业绩系数</div>
          <el-table :data="info.vipCouponList" size="mini" :border="true" empty-text>
            <el-table-column label="VIP劵包" width="70" prop="name" show-overflow-tooltip></el-table-column>
            <el-table-column class="vip-color" prop="desc" label="有效期折算业绩系数">
              <template slot-scope="scope">
                <span class="vip-color">{{ scope.row.desc }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- End -->
      </div>
    </div>
    <!-- 公式 -->
    <div class="formula-wapper">
      <div class="formula-title">公式</div>
      <!-- 条件区间公式 -->
      <div  class="formula-list">
        <p class="formula-item">
          <span class="label">销售的提成金额 = </span>
          <span >销售金额</span> ×
          <span class="color-red">区间售价对应的销售提成</span> ×
          <span class="color-orange">售价折算业绩系数</span> ×
          <span class="color-green">运营所选的销售提成系数（如有多项则将多项累乘）</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
        <p class="formula-item">
          <span class="label">经理的提成金额 = </span>
          <span >销售金额</span> ×
          <span >区间售价对应的经理提成</span> ×
          <span class="color-orange">售价折算业绩系数</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
        <p class="formula-item">
          <span class="label">总监的提成金额 = </span>
          <span >销售金额</span> ×
          <span >区间售价对应的总监提成</span> ×
          <span class="color-orange">售价折算业绩系数</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
        <p class="formula-item">
          <span class="label">折算业绩 = </span>
          <span >销售金额</span> ×
          <span class="color-orange">售价折算业绩系数</span> ×
          <span class="color-purple">有效期折算业绩系数</span> ×
          <span class="EC808D">适用应用规则折算业绩系数</span> ×
          <span class="color-blue">预算范围折算业绩系数</span> ×
          <span class="color-yellow">销售下单选中的VIP券包折算业绩系数</span>
        </p>
      </div>
      <p class="formula-note">注意：如果方案表中未出现公式中的项，则该项不参与计算</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['info'],
  methods: {
    formatPercent(value) {
      if (value == null || value === '' || Number.isNaN(Number(value))) {
        return '--'
      }
      return `${Number(value)}%`
    }
  },
}
</script>

<style>

table{
  border-collapse: separate;
}
.images-wapper {
  /* border-top: 1px solid #d6dbe5; */
  border-top: 1px dashed #d6dbe5;
  margin-top: 30px;
  display: inline-block;
}
.plan-table-title-one{
  width: 100%;
  background-color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  border-right: 1px solid #d6dbe5;
}
.info-wapper .el-image {
  width: 210px;
  height: 100px;
  border-radius: 6px;
  margin-left: 15px;
}

.table-wapper {
  margin-left: 130px;
  width: 550px;
}

.table-wapper label {
  padding: 10px 0;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: bold;
  border: 1px solid #d6dbe5;
  border-bottom: none;
}

.table-wapper table {
  border: 1px solid #d6dbe5;
  width: 100%;
}

.table-wapper td {
  padding: 10px;
  border-bottom: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
}

.table-wapper tr:first-child td {
  font-weight: bold;
  background: #f9f9f9;
}

.plan-table-wapper {
  font-size: 12px;
  margin-bottom: 30px;
  border-bottom: 1px solid #d6dbe5;
}

.plan-table-wapper td {
  padding: 6px;
  border-top: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
  position: relative;
  /* white-space: nowrap; */
  /* width: 11%; */
}

.plan-table-wapper input {
  color: #383e43;
  width: 50px;
  text-align: center;
}

.plan-table-wapper tr:first-child {
  border-top: 1px double #909399;
  border-width: 3px;
}

.plan-table-wapper table {
  width: 100%;
}

.plan-table-title {
  font-weight: bold;
  background: #f9f9f9;
  text-align: center;
}

.plan-table-title td {
  background-color: #e6e6e6;
  height: 50px;
  padding: 0;
  line-height: 50px;
  text-align: center;
}

.plan-side-cell {
  vertical-align: top;
  white-space: normal;
  padding: 0 !important;
}

.inner-cell-table {
  width: 100%;
  /* border-collapse: collapse; */
}

.inner-cell-table td {
  border-top: 1px solid #d6dbe5 !important;
  border-right: 1px solid #d6dbe5 !important;
  border-bottom: none;
  border-left: none;
  white-space: normal;
  line-height: 18px;
  padding: 8px 6px;
}

.new-table-wapper {
  width: 1250px;
  display: flex;
  border: 0.5px solid #d6dbe5;
  overflow-x: scroll;
}

.table-one {
  width: 600px;
  flex-shrink: 0;
  border-right: 0.5px solid #d6dbe5;
}

.table-two {
  width: 250px;
  flex-shrink: 0;
  border-right: 0.5px solid #d6dbe5;
}

.table-thr {
  width: 200px;
  flex-shrink: 0;
  border-right: 0.5px solid #d6dbe5;
  max-height: 400px;
  overflow-y: auto;
}

.table-four {
  width: 200px;
  flex-shrink: 0;
  border-right: 0.5px solid #d6dbe5;
}
.table-five{
  border-right: 0.5px solid #d6dbe5;
}

.new-table-title {
  height: 50px;
  background-color: #e6e6e6;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-right: 1px solid #d6dbe5;
  border-top: 1px solid #d6dbe5;
  box-sizing: border-box;
  padding: 0 6px;
}

.performanceRule-table .cell {
  height: 30px;
  line-height: 30px;
  background-color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6dbe5;
}

.performanceRuleFactor {
  height: 30px;
  color: #ec808d;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6dbe5;
  font-weight: bold;
}

.condition {
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6dbe5;
  width: 100%;
  word-break: break-word;
  line-height: 14px;
  padding: 4px 12px;
}

.saleRoyalty-color {
  color: #D9001B;
}

.saleConversionFactor-color {
  color: #F59A23;
}

.coefficient-color {
  color: #C280FF;
}

.vip-color {
  color: #AAAA00;
}
.sale-conversion-factor-wapper{
  flex-shrink: 0;
  border-right: 0.5px solid #d6dbe5;
}
.package-list-wapper{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
}
/* 新增溢出显示省略号 */
.package-list-wapper span{
  display: inline-block;
  text-align: center;
  background-color: #e6e6e6;
  /* width: 100%; */
  max-width: 190px;
  height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
}
.package-list-item{
  height: 25px;
  border-right: 0.5px solid #d6dbe5;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.package-table-wapper{
  width: 100%;
  display: flex;
}
.pack-color{
  color: #63A103;
}

/* 公式样式 */
.formula-wapper {
  margin-top: 30px;
  padding: 20px;
  background: #fff;
  font-size: 12px;
  width: 1200px;
  overflow:auto ;
}

.formula-title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.formula-list {
  margin-bottom: 15px;
}

.formula-item {
  margin-bottom: 12px;
  line-height: 1.8;
}

.formula-item .label {
  font-weight: bold;
}

.formula-note {
  text-align: center;
  font-size: 12px;
  color: #666;
  margin-top: 15px;
}

/* 颜色定义 */
.color-red {
  color: #D9001B;
}

.color-orange {
  color: #F59A23;
}

.color-purple {
  color: #C280FF;
}

.color-yellow {
  color: #AAAA00;
}

.color-green {
  color: #63A103;
}
.formula-item{
  display: flex;
  align-items: center;
  justify-content: center;
}
.EC808D{
  color: #EC808D;
}
.color-blue{
  color: #02A7F0;
}
.table-five{
  width: 120px;
  flex-shrink: 0;
}
.budgetConversionFactor{
  width: 100%;
  border: 1px solid #d6dbe5;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sale-new-table-title{
  background-color: #e6e6e6;
}
.sale-new-table-title-text{
  height: 25px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e6e6e6;
  border: 1px solid #d6dbe5;
  border-top: none;
  box-sizing: border-box;
}
</style>